<script>
	import { speak } from './speak';

	export let text = '';

	//@ts-ignore
	function enter(event) {
		if (event.code == 'Enter') speak(text);
	}
</script>

<h1 class="text-xl font-bold mb-2 mt-10">Freitext</h1>
<div class="flex space-x-4">
	<input
		type="text"
		on:keypress={enter}
		class="flex-1 border border-gray-300 rounded text-xl px-2"
		bind:value={text}
	/>
	<button
		on:click={() => {
			speak(text);
		}}
		class="px-10 bg-red-600 rounded-lg drop-shadow text-white p-2 text-2xl font-medium"
	>
		▶ Play</button
	>
</div>
